// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";
import router from "./configs/router";

import store from "./vuex/store";

import App from "./App";
import axios_helper from "./utils/axios_helper"

Vue.config.productionTip = false;

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCVubXh4J6rnmHxt3TQXfPOgqHtPQYq7Mo",
    libraries: "places"
  }
});

import ButtonText from "@/spa/components/LayoutButtonText";
Vue.component("ButtonText", ButtonText);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});

// axios_helper({app, router, store, Vue})



// WEBPACK FOOTER //
// ./src/main.js